import React from "react";
import { useParams, useSearchParams } from "react-router-dom";

import HualpenSubida from "../CargaHualpen/CreateSubida";
import HualpenBajada from "../CargaHualpen/CreateBajada"; // <- Asegúrate de importar esta

const CrearServiciosPage = () => {
  const { id } = useParams(); // ID desde la ruta (ej: /CrearServices/2)
  const [searchParams] = useSearchParams(); // Parámetros como ?type=SUBIDA
  const type = searchParams.get("type"); // "SUBIDA" o "BAJADA"

  if (type === "BAJADA") {
    return <HualpenBajada id={id} />;
  } else if (type === "SUBIDA") {
    return <HualpenSubida id={id} />;
  }
};

export default CrearServiciosPage;
